import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Login from "./default/login";
// import Dashboard from "./components/Dashboard";
import MyResearch from "./components/myResearch";
import ClinicalResearch from "./components/clinicalresearch";
import ClinicalTrail from "./components/ClinicalTrail/clinicaltrail";
import Layout from "./Layout";
import AdminDashboard from "./components/Admin/AdminDashboard";
import UserMangement from "./components/Admin/UserMangement";
import ForgotPassword from "./Forgotpassword";
// preliminaryProtocols
import Profile from "./profile";
import PreliminaryProtocols from "./components/preliminaryProtocols";



function App() {
  return (
    <Router>
      <Routes>
        {/* LOGIN (NO NAVBAR, NO SIDEBAR) */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/clinicaltrial" element={<ClinicalTrail />} />

        {/* ALL OTHER PAGES USE LAYOUT */}
        <Route element={<Layout />}>
          <Route path="/adminDashboard" element={<AdminDashboard />} />
          <Route path="/userManagement" element={<UserMangement />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route path="/myresearch" element={<MyResearch />} />
          <Route path="/clinicalresearch" element={<ClinicalResearch portNumber="3002" />} />
          <Route path="/r&d" element={<ClinicalResearch portNumber="3001" />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/preliminaryProtocols" element={<PreliminaryProtocols />} />

          {/* preliminaryProtocols */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
